/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authDeleteContent.defs.js'
export * as $defs from './authDeleteContent.defs.js'
